import styled from 'styled-components';
import { Button } from 'junto-ui';
import { tokens } from '@plataforma/components';
import { colors, grid, fonts } from '_/styles';

export const Title = styled.h1`
  color: ${colors.textMain};
  font-weight: ${tokens.font.weight.semibold};
  font-size: ${fonts.large};
  ${({ margin }) => margin && `margin-bottom:${grid.large}`}
`;

export const Date = styled.span`
  color: ${colors.textOption};
  font-size: ${fonts.default};
`;

export const Protocol = styled.p`
  ${tokens.font.xs};
  color: ${colors.textOption};
  margin-top: ${tokens.spacing.s};
  margin-bottom: ${tokens.spacing.xl};
`;

export const Group = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: ${grid.small};
`;

export const ActionButton = styled(Button)`
  width: ${props => (props.isShortButton ? '16rem' : '100%')};
  margin-top: ${props => (props.isShortButton ? '3rem' : grid.large)};
  margin-bottom: ${props => (props.isShortButton ? '3rem' : grid.large)};
  font-family: ${tokens.font.family.metropolis};
  font-weight: ${tokens.font.weight.semibold};
`;

export const LawTextValue = styled.span`
  display: block;
  color: ${colors.textMain};
  font-size: ${fonts.size.default};
`;
